<template>
  <div class="static-content-wrapper">
    <div style="margin:30px!important;">
      <h1>Fehler 404, diese Seite konnte leider nicht gefunden werden.</h1>
      <p>
        <router-link to="/">Zurück zur Startseite</router-link>
      </p>
    </div>
  </div>
  <MedauFooter />
</template>

<script>
import MedauFooter from "@/components/static/MedauFooter.vue";

export default {
  components: {MedauFooter},
  mounted() {
    this.$store.commit("setPageTitle", "Fehler 404");
  },
}
</script>